<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import AppSidebar from "@/components/AppSidebar.vue";
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import "vue-sonner/style.css";

const route = useRoute();

/**
 * Let the journey viewer bypass the Reports Tools chrome so the opened tab can
 * behave like a dedicated standalone viewer instead of a nested tool page.
 */
const isStandaloneViewerRoute = computed(
  () => route.meta.standaloneViewer === true,
);
</script>
<template>
  <main
    v-if="isStandaloneViewerRoute"
    class="bg-background w-full min-w-0 h-screen overflow-hidden"
  >
    <router-view />
  </main>
  <SidebarProvider v-else class="h-screen overflow-hidden">
    <AppSidebar />
    <SidebarInset class="h-screen min-w-0 overflow-hidden">
      <!-- Keep the inset constrained to the remaining shell width. Using
           viewport-width sizing here makes editor surfaces extend behind the
           sidebar and pushes right-side panels off-canvas. -->
      <!-- <SidebarTrigger class="top-[0] left-[0] z-2 sticky" /> -->

      <router-view />
    </SidebarInset>
  </SidebarProvider>
  <Toaster class="pointer-events-auto" position="top-right" />
</template>
